import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {useRefraMutation} from '../../useRefraMutation'

import {mutations} from '@refra/api/mutations'
import {logger} from '@refra/modules/common/utils'

export const useAddComment = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.addComment,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useAddComment')
        .extras({errorDetails})
        .error('Error occurred while adding a comment')

      spawnErrorToast(t('error.addComment'))
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['comments']})
      spawnSuccessToast(t('success.addComment'))
    }
  })
}
